import { EuroTwoTone } from "@mui/icons-material";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetMessages, GetMessagesById } from "../../services/MessageService";
import { GetGroups } from "../../services/MessagingService";

interface Message {
  id: string;
}
interface Group {
  id: string;
  messages: [];
}
interface GroupState {
  groups: Group[];
  status: string;
  error: string | undefined;
}
const initialState = {
  groups: [] as any,
  status: "idle",
  error: "" as string | undefined,
};

export const fetchGroups = createAsyncThunk(
  "/groups/fetchGroups",
  async (thunkAPI) => {
    const response = await GetGroups();
    //console.log("grops", response.data.data);
    return response.data;
  }
);

export const fetchGroupMessages = createAsyncThunk(
  "/groups/fetchGroupMessages",
  async (thunkAPI) => {
    // const response = await GetGroups();
    // console.log(response.data.data);
    // return response.data;
    return;
  }
);

export const updateGroups = createAsyncThunk(
  "/groups/updateGroups",
  async (data: any) => {
    const response = await GetMessagesById(data.messageId);

    return { message: response.data.data, id: data.groupId };
  }
);

const groupsSlice = createSlice({
  name: "groups",
  initialState: initialState,
  reducers: {
    groupAdded: (state, action: PayloadAction<any>) => {
      state.groups.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGroups.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchGroups.fulfilled, (state, action: PayloadAction<any>) => {
        state.groups = action.payload.data;
        //	console.log(state.groups);

        state.status = "idle";
      })
      .addCase(fetchGroups.rejected, (state, action) => {
        //console.log(action);
        state.error = action.error.message;
        state.status = "idle";
      })
      .addCase(updateGroups.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(updateGroups.fulfilled, (state, action) => {
        //	console.log("apl", action.payload);

        const updateGroupIndex = state.groups.findIndex(
          (p: any) => p.id === action.payload.id
        );
        //	console.log(updateGroupIndex);

        if (updateGroupIndex === -1) {
          //console.log(-1);
        } else {
          const messageIndex = state.groups[
            updateGroupIndex
          ].messages.findIndex((p: any) => p.id === action.payload.message.id);

          if (messageIndex === -1) {
            state.groups[updateGroupIndex].messages.push(
              action.payload.message
            );
          }
        }

        state.status = "idle";
      })
      .addCase(updateGroups.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "idle";
      });
  },
});

export const selectAllGroups = (state: any) => state.groups.groups;
export const { groupAdded } = groupsSlice.actions;

export default groupsSlice.reducer;
